import React, {useEffect} from 'react'
import { useTranslation } from 'react-i18next'
import {useSearchParams} from 'react-router-dom'
import {withTitle} from '@/router/utils'
import {observer} from 'mobx-react'
import {Spin, Typography} from 'antd'
import {useInjection} from 'dna-react-ioc'
import {Button} from '@/components'
import {IValidateRefCodeStore} from '.'
import styles from './styles.scss'

export const ValidateRefCodeStoreSymbol = Symbol('ValidateRefCodeStore')

const ValidateRefCode = observer(() => {
    const {t} = useTranslation()
    const store = useInjection<IValidateRefCodeStore>(ValidateRefCodeStoreSymbol)
    const {isLoading, isValid, validateRefCode, goToLoginPage, showMessage} = store
    const [queryParams] = useSearchParams()
    const ref = queryParams.get('ref') || ''

    useEffect(() => {
        if (ref) {
            validateRefCode(ref)
        } else {
            goToLoginPage()
        }
    }, [ref])

    return (
        <Spin spinning={isLoading}>
            {!isValid && !isLoading && (
                <div className={styles.root}>
                    <div className={styles.image}></div>
                    <Typography.Title className={styles.title} level={5}>
                        {t('ValidateRefCode.title')}
                    </Typography.Title>

                    <Button className={styles.button} type={'primary'} onClick={goToLoginPage}>
                        {t('ValidateRefCode.submit')}
                    </Button>
                </div>
            )}
        </Spin>
    )
})

export default withTitle(ValidateRefCode)
